import axios from 'axios';
import config from '../../../assets/config';
import { createAsyncThunk } from '@reduxjs/toolkit';
import authHeader from '../authHeader';

const backendURL = config.apiURL;
const base_url =window.location.origin+"/";

export const serviceRefGrid = createAsyncThunk(
    'service-ref-grid',
    async (payload,{rejectWithValue})=>{
        try{
            const {data} = await axios.post(
                `${base_url}api/api/Security/GetUserTypeServiceSearch`,
                payload,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                return rejectWithValue(error.response.data)
            }else{
                return rejectWithValue(error.response.data)
            }
        }
    }
);
export const userTypeRoleDpdn = createAsyncThunk(
    'user-type-role-dropdown',
    async (id)=>{
        try{
            const {data} = await axios.get(
                `${base_url}api/api/Security/GetUserTypeList/${id}`,
               { headers:authHeader()}
            );
            return data;
        }catch(error){
            if(error.response && error.response.data){
                // return rejectWithValue(error.response.data)
            }else{
                // return rejectWithValue(error.response.data)
            }
        }
    }
);


// GetUserTypeServiceSearch,GetUserTypeList